<app-page-well>
  <div class="no-access">
    <div class="lock-icon">
      <lib-icon name="lock"></lib-icon>
    </div>
    <h2 class="no-access-heading">Your Access Has Expired</h2>
    <p class="body">Your access to the Resolve Practice Portal has expired. Contact your sales representative to get support or restore
      access.</p>
  </div>
</app-page-well>